/**
 * Constantes de chaves do localStorage utilizadas pela aplicação
 */

export const STORAGE_KEY_ACCESS = '@nectar/access_token';
export const STORAGE_KEY_REFRESH = '@nectar/refresh_token';
export const STORAGE_KEY_NAV_FAVORITES = '@nectar/nav_favorites';
export const STORAGE_KEY_APP_TITLE = '@nectar/app_title';
export const STORAGE_KEY_APP_FAVICON = '@nectar/app_favicon';
